module.exports = __webpack_public_path__ + "img/solution13.671365e2.png";